import { motion } from 'framer-motion';
import styled from 'styled-components';

export const SliderWrapper = styled(motion.div)`
  position: relative;
  width: 100%;
  height: fit-content;
  overflow: hidden;
`;

export const SliderContent = styled(motion.div)`
  height: 100%;
  width: fit-content;
  min-width: 100%;
  cursor: grab;
`;
